export default __webpack_public_path__ + "static/media/DSC_0102 (1).7940814b.jpg";